import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getNotifications = (params) => axios.get(`${getWorkspaceId()}/notifications`, { params })
const updateNotification = (id) => axios.patch(`${getWorkspaceId()}/notifications`, { id })

const getNotificationSettings = () => axios.get('notification-settings')
const updateNotificationSettings = (formatData) => axios.patch('notification-settings', formatData)

const getNotificationLowBalance = () => axios.get(`${getWorkspaceId()}/notifications/low-balance`)
const updateNotificationLowBalance = (formatData) => axios.put(`${getWorkspaceId()}/notifications/low-balance`, formatData)

export {
    getNotifications,
    updateNotification,
    getNotificationSettings,
    updateNotificationSettings,
    getNotificationLowBalance,
    updateNotificationLowBalance,
}
